import { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import getGqlClient from '../clients/graphql/marketplace';

import { FilterUtils } from '../../..';
import { getFacetSearchQuery } from '../queries/graphql/facetSearch';

const FacetSearchContext = createContext({
  facetSearch: {},
  filters: {},
  setFilters: () => {}
});

export const FacetSearchProvider = ({
  cityId,
  initialFilters = {},
  children
}) => {
  const [filters, setFilters] = useState(initialFilters);
  const [facetSearch, setFacetSearch] = useState({});

  useEffect(() => {
    if (!cityId) {
      return;
    }
    const requestFacetSearch = async () => {
      try {
        const facetSearchResponse = await getFacetSearchQuery(getGqlClient())(
          cityId,
          FilterUtils.adaptFiltersFromUrl(filters)
        );

        setFacetSearch(facetSearchResponse.data.facetSearch);
      } catch (error) {
        console.error(error);
      }
    };

    requestFacetSearch();
  }, [filters, cityId]);

  const resetFilters = () => {
    setFilters(initialFilters);
  };

  return (
    <FacetSearchContext.Provider
      value={{ facetSearch, filters, setFilters, resetFilters }}
    >
      {children}
    </FacetSearchContext.Provider>
  );
};

FacetSearchProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  cityId: PropTypes.string.isRequired,
  initialFilters: PropTypes.object
};

export const useFacetSearchContext = () => useContext(FacetSearchContext);
export const FacetSearchConsumer = FacetSearchContext.Consumer;

export default {
  FacetSearchProvider,
  FacetSearchConsumer,
  useFacetSearchContext
};
